/* eslint-disable max-len */
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { UserLiteData } from '../../../api/ApiTypes';
import { Colors } from '../../../ui';
import { Avatar } from '../../common/Avatar';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { useHangoutUser } from '../../hangouts/helpers/HangoutUserObserver';

const UserItemInfo = styled.div`
    flex: 1 1 auto;
    padding: .25rem 1rem .25rem 0;
`;

const UserItemHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: .5rem;

    color: ${Colors.text};
    font-size: 1.125rem;
    font-weight: 450;
    white-space: nowrap;
`;

const UserItemBody = styled.div`
    color: ${Colors.textLighter};
    font-size: .875rem;
`;

const UserItemStatus = styled.div<{ state: 'online' | 'offline' }>`
    border-radius: 50%;
    width: .5em;
    height: .5em;
    background: ${p => p.state === 'online' ? Colors.positive : 'transparent'};
    border: solid .125rem ${p => p.state === 'online' ? Colors.positive : Colors.gray400};
`;

export const UserInfoView = ({ user, children }: { user: UserLiteData, children?: ReactNode }) => {

    const { online } = useHangoutUser(user.id) ?? {};

    return <Flexer padding=".5">
        <Flexer flex="row" gap="1">
            <Avatar.ForUser user={user} size="5" variant="roundish" />
            <UserItemInfo>
                <UserItemHeader>
                    <span>{user.name}</span>
                    <UserItemStatus state={online ? 'online' : 'offline'} />
                </UserItemHeader>
                <UserItemBody>
                    {user.email} <br />
                    {user.id}
                </UserItemBody>
            </UserItemInfo>
        </Flexer>
        {children}
    </Flexer>;
};
